import * as React from 'react';
import { memo, useEffect } from 'react';

import { spacing } from '@rbilabs/universal-components/themes';
import { useRouter } from 'expo-router';
import { useIntl } from 'react-intl';
import { StyleSheet, View, ViewStyle } from 'react-native';

import { Helmet } from 'components/helmet';
import { BkLogoRevamp } from 'components/logo/bk-logo-revamp';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { primitive } from 'styles/constants/primitives';
import { routes } from 'utils/routing';

import { useWhopperGuaranteeRedemptionCode } from './hooks/use-whopper-guarantee-redemption-code';
import WhopperQrCodeWidget from './whopper-qr-code-widget';
import WhopperShortCodeWidget from './whopper-short-code-widget';

const LoyaltyWhopperGuarantee: React.FC = () => {
  const { formatMessage } = useIntl();
  const { replace } = useRouter();
  const isDesktop = useIsDesktopBreakpoint();

  const { shortCode, shortCodeState, isShortCodeLoading } = useWhopperGuaranteeRedemptionCode();

  // Redirect desktop users
  useEffect(() => {
    if (isDesktop) {
      replace(routes.base);
    }
  }, [isDesktop, replace]);

  return (
    <View style={styles.pageContainer}>
      <View style={styles.headerContainer}>
        <View style={styles.logoContainer}>
          <BkLogoRevamp />
        </View>
      </View>
      <View style={styles.contentContainer}>
        <Helmet
          title={formatMessage({
            defaultMessage: 'whopperGuarantee',
            id: 'whopperGuarantee',
          })}
        />
        <View style={styles.cardContainer}>
          <WhopperShortCodeWidget
            shortCode={shortCode}
            shortCodeState={shortCodeState}
            isShortCodeLoading={isShortCodeLoading}
          />
          <WhopperQrCodeWidget shortCode={shortCode} />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  pageContainer: {
    flex: 1,
  } as ViewStyle,
  headerContainer: {
    backgroundColor: primitive.bk.$mayoEggWhite,
    paddingTop: spacing.$4,
    paddingBottom: spacing.$4,
  },
  logoContainer: {
    alignItems: 'center',
  },
  contentContainer: {
    flex: 1,
    paddingTop: spacing.$4,
    paddingBottom: spacing.$4,
    paddingLeft: spacing.$4,
    paddingRight: spacing.$4,
    backgroundColor: primitive.bk.$bbqBrown,
  } as ViewStyle,
  cardContainer: {
    borderRadius: 16,
    overflow: 'hidden',
  },
});

export default memo(LoyaltyWhopperGuarantee);
